module.exports = __webpack_public_path__ + "img/2021jy_intro2.b6fd4e34.jpeg";